import ReactDOM from "react-dom";
import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import DeskIcon from "assets/icons/book.svg?react";
import EditIcon from "assets/icons/edite.svg?react";
import CloseIcon from "assets/icons/close.svg?react";
import BinIcon from "assets/icons/bin.svg?react";
import { useContext, useEffect, useRef, useState } from "react";
import ModalsManagerContext from "contexts/ModalsManager";
import { useOnClickOutside } from "hooks/useClickOutside";
import taskService from "api/taskService";
import ActionsContext from "contexts/ActionsContext";
import deskService from "api/deskService";
import { ItemKind } from "dto/IKindItems";

function stripHtml(html) {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  const decodedHtml = txt.value;

  return decodedHtml.replace(/<[^>]+>/g, "");
}

const EventInfoModal: FC<Props> = ({ event, position, toggle, refetch }) => {
  const { modals, setModals } = useContext(ModalsManagerContext);
  const ref = useRef<HTMLDivElement>();
  const [pos, setPos] = useState([0, 0]);

  const { mutate: deleteTask } = taskService.useDeleteTask();
  const { mutate: setDesk } = deskService.useSetDesk();

  const checkPosition = () => {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const modalPosition = ref.current.getBoundingClientRect();
    const endOfModalX = position[0] + modalPosition.width;
    const endOfModalY = position[1] + modalPosition.height;

    let newX = position[0];
    let newY = position[1];

    if (endOfModalX > windowWidth) {
      newX = windowWidth - modalPosition.width - 8;
    }

    if (endOfModalY > windowHeight) {
      newY = windowHeight - modalPosition.height - 8;
    }

    setPos([newX, newY]);
  };

  useOnClickOutside(ref, () => {
    toggle();
  });

  useEffect(() => {
    if (!ref?.current) return;
    checkPosition();
  }, [ref, position]);

  const { tasks, setTasks } = useContext(ActionsContext);

  const handleRemoveTask = () => {
    deleteTask(
      {
        Id: event.id,
        MoveToTrash: true,
      },
      {
        onSuccess: () => {
          const newTasks = [...tasks].filter((t) => t.id !== event.id);
          setTasks(newTasks);
          toggle();
        },
      }
    );
  };

  const handleAddDesk = () => {
    setDesk(
      {
        Items: [{ Id: event.Id, Kind: ItemKind.CalendarEvent }],
        Show: !event.IsDeskActive,
      },
      {
        onSuccess: () => {
          toggle();
          refetch();
        },
      }
    );
  };

  return ReactDOM.createPortal(
    <div
      ref={ref}
      style={{
        left: pos[0],
        top: pos[1],
        opacity: pos[0] === 0 ? 0 : 1,
      }}
      className={styles.modal}
    >
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <div className={styles.title}>Wydarzenie</div>
          <div className={styles.options}>
            {!event.IsDeskActive && (
              <div className={styles.box}>
                <DeskIcon className={styles.icon} onClick={handleAddDesk} />
              </div>
            )}
            {!event.readOnly && (
              <div className={styles.box}>
                <BinIcon className={styles.icon} onClick={handleRemoveTask} />
              </div>
            )}
            {!event.readOnly && (
              <div className={styles.box}>
                <EditIcon
                  className={styles.icon}
                  onClick={() => {
                    localStorage.setItem("action", JSON.stringify(event));
                    localStorage.setItem("actionType", "EVENT");
                    setModals({ ...modals, createTask: true, hide: false });
                    toggle();
                  }}
                />
              </div>
            )}
            <div className={`${styles.box} ${styles.close}`}>
              <CloseIcon className={styles.icon} onClick={toggle} />
            </div>
          </div>
        </div>
        <div className={styles.div}></div>
        <div className={styles.content}>
          <div className={styles.contentTitle}>
            {event.title ?? event.Title}
          </div>
          <div className={styles.contentBody}>
            {stripHtml(event.note ?? event.Note ?? event.description ?? "")}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default EventInfoModal;
